import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import TranslationIndicator from '../../common/components/TranslationIndicator';
export default function addPostTranslationIndicator() {
  extend(CommentPost.prototype, 'oninit', function () {
    this.subtree.check(() => !!this.attrs.post.loadingOriginal);
  });
  extend(CommentPost.prototype, 'headerItems', function (items) {
    const post = this.attrs.post;
    if (post.isHidden() || !(post.isTranslated?.() || post.showingOriginal)) return;
    items.add('translation', m(TranslationIndicator, {
      model: post
    }), -10);
  });
}
flarum.reg.add('glowingblue-translate', 'forum/extenders/addPostTranslationIndicator', addPostTranslationIndicator);